/**
 * The media type of a map file, by its name. Cache Storage keeps the bytes of
 * a downloaded file but not its type, and an `<img>` decodes a `blob:` SVG
 * only when the blob is typed `image/svg+xml` — an untyped label set loads as
 * a broken image and the map shows no station names.
 */
export function mapFileContentType(name: string): string {
  if (name.endsWith('.svg')) return 'image/svg+xml'
  if (name.endsWith('.json')) return 'application/json'
  return 'application/octet-stream'
}
